import { apiClient } from './ApiService';
import {
  droneCommanderCampaignsAddUsers,
  droneCommanderCampaignsCreate,
  droneCommanderCampaignsGetCampaignUsers,
  droneCommanderCampaignsOrgRead,
  droneCommanderCampaignsRemoveUsers,
  droneCommanderCampaignsPartialUpdate,
  type User,
  type Campaign,
  type CampaignCreateInput,
  type CampaignStatus
} from './types/api.generated';
import {
  droneCommanderCampaignsOrgReadResponse,
  droneCommanderCampaignsPartialUpdateResponse,
  droneCommanderCampaignsCreateBody,
  droneCommanderCampaignsAddUsersBody,
  droneCommanderCampaignsRemoveUsersBody,
  droneCommanderCampaignsGetCampaignUsersResponse
} from './types/schemas.zod';

const getCampaigns = async (organizationId: number): Promise<Campaign[]> => {
  const response = await droneCommanderCampaignsOrgRead(organizationId.toString());
  if (response.status === 200) {
    const validatedResponse = droneCommanderCampaignsOrgReadResponse.parse(response.data);
    return validatedResponse.data.campaigns;
  }
  return [];
};

const updateCampaignStatus = async (campaignId: string, newStatus: CampaignStatus): Promise<Campaign | undefined> => {
  const response = await droneCommanderCampaignsPartialUpdate(campaignId, { status: newStatus });
  if (response.status === 200) {
    const validatedResponse = droneCommanderCampaignsPartialUpdateResponse.parse(response.data);
    return validatedResponse.data.campaign;
  }
};

const createCampaign = async (newCampaignData: CampaignCreateInput): Promise<Campaign | undefined> => {
  const validatedBody = droneCommanderCampaignsCreateBody.parse(newCampaignData);
  const response = await droneCommanderCampaignsCreate(validatedBody);
  if (response.status === 201) {
    return response.data.data.campaign;
  }
};

const addUsersInCampaign = async (campaignId: string): Promise<boolean> => {
  const validatedBody = droneCommanderCampaignsAddUsersBody.parse({ campaign_id: campaignId });
  const response = await droneCommanderCampaignsAddUsers(validatedBody);
  return response.status === 201;
};

const removeUsersFromCampaign = async (campaignId: string): Promise<boolean> => {
  const validatedBody = droneCommanderCampaignsRemoveUsersBody.parse({ campaign_id: campaignId });
  const response = await droneCommanderCampaignsRemoveUsers(validatedBody);
  return response.status === 204;
};

const getCampaignUsers = async (campaignId: string): Promise<User[]> => {
  const response = await droneCommanderCampaignsGetCampaignUsers(campaignId);
  if (response.status === 200) {
    const validatedResponse = droneCommanderCampaignsGetCampaignUsersResponse.parse(response.data);
    return validatedResponse.users;
  }
  return [];
};

export const CampaignService = {
  getCampaigns,
  updateCampaignStatus,
  createCampaign,
  addUsersInCampaign,
  removeUsersFromCampaign,
  getCampaignUsers
};
